import React, { FC } from 'react';
import './ErrorDisplay.css';

interface ErrorDisplayProps {
  error: Error | string;
  title?: string;
  showReferenceId?: boolean;
  onRetry?: () => void;
  className?: string;
}

const ErrorDisplay: FC<ErrorDisplayProps> = ({ 
  error, 
  title = 'An error occurred', 
  showReferenceId = true,
  onRetry,
  className = ''
}) => {
  const errorMessage = typeof error === 'string' ? error : error.message;
  const referenceId = (error as any)?.referenceId;
  const statusCode = (error as any)?.statusCode;
  const isInternalError = statusCode && statusCode >= 500;

  return (
    <div className={`error-display ${className}`}>
      <div className="error-icon">⚠️</div>
      <h3 className="error-title">{title}</h3>
      
      <div className="error-message">
        {errorMessage.split('\n').map((line, index) => (
          <p key={index} className="error-line">
            {line}
          </p>
        ))}
      </div>

      {showReferenceId && referenceId && isInternalError && (
        <div className="reference-id-section">
          <p className="reference-id-label">Reference ID:</p>
          <code className="reference-id">{referenceId}</code>
          <p className="reference-id-help">
            Please include this ID when reporting this issue to support.
          </p>
        </div>
      )}

      {onRetry && (
        <button 
          onClick={onRetry} 
          className="error-retry-button"
        >
          Try Again
        </button>
      )}
    </div>
  );
};

export default ErrorDisplay; 